import { acceptHMRUpdate, defineStore } from 'pinia'

export const useAppState = defineStore('appState', {
    state: () => ({
        // false = sidebar is hidden, true = sidebar is visible
        sidebar: false
    }),
    actions: {
        /**
         * Start part for the map toggle button
         */
        toggleFieldListVisibility() {
            this.sidebar = !this.sidebar
        },
        showFieldList() {
            this.sidebar = true
        },
        hideFieldList() {
            this.sidebar = false
        },
        resetButtonState() {
            this.sidebar = false
        },
        /**
         * End part for the map toggle button
         */
    }
})

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useAppState, import.meta.hot))
}